<template>
    <div>


        <input type="text" placeholder="表" v-model="tb">

        <el-button @click="_do">复制10条</el-button>


        <el-input v-model="text" type="textarea" placeholder=""></el-input>
        <el-button type="primary" size="default" @click="_cate">提交</el-button>


    </div>
</template>
<script>
export default {
    data() {
        return {
            tb: '',
            text: ''
        };
    },
    created() {

    },
    methods: {
        _cate() {
            this.$http.post('index/cate', {
                text: this.text
            }).then(res => {

            })
        },
        _do() {

            this.$http.post('index/copy_data', {
                table: this.tb
            }).then(res => {

            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>